import { render, staticRenderFns } from "./StepContainer.vue?vue&type=template&id=2a63691b&scoped=true&"
import script from "./StepContainer.vue?vue&type=script&lang=js&"
export * from "./StepContainer.vue?vue&type=script&lang=js&"
import style0 from "./StepContainer.vue?vue&type=style&index=0&id=2a63691b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a63691b",
  null
  
)

export default component.exports